export { default as LatestUpdateLink } from './component';
